// @ts-check
/* global module */
'use_strict';

import { initialize_google_autocomplete } from '../tv_third_party_integrations/initialize_google_autocomplete';

export class CartView {

    observer: MutationObserver;

    /**
     * Instantiate the class, and call the function to handle the page content.
     */
    constructor() {
        const accessories_container = document.querySelector('.accessories-container');
        if (accessories_container) {
        // Create an observer to watch the scroll buttons of owl carousel. Once they exist bind the buttons.
            this.observer = new MutationObserver(this.handle_accessories.bind(this));
            this.observer.observe(accessories_container, {childList: true, subtree: true});
        }

        const cart_items = document.getElementById('cart_items');
        if (cart_items) {
            const main_content = document.querySelector('body');
            this.observer = new MutationObserver(this.handle_cart_modals.bind(this));
            this.observer.observe(main_content, {childList: true, subtree: true});
        }

        // Mobile close button.
        const mobile_close_button = document.getElementById('js-close-estimate-modal');
        mobile_close_button.addEventListener('click', () => {
            (document.querySelector('.ui-dialog-titlebar-close') as HTMLElement).click();
        });

        initialize_google_autocomplete(true);
    }

    /**
     * Add functionality for the accessories product scroller since CS cart functionality is disabled here.
     * 
     * @returns {void}
     */
     handle_accessories() : void {
        const prev_btn = document.querySelector('.accessories-container .owl-prev');
        const next_btn = document.querySelector('.accessories-container .owl-next');
        prev_btn.addEventListener('click', () => this.translate_accessories_carousel('prev'));
        next_btn.addEventListener('click', () => this.translate_accessories_carousel('next'));

        this.observer.disconnect();
    }

    /**
     * Dynamically handle the z-indexs of modal overlays in the cart.
     * 
     * @returns {void}
     */
    handle_cart_modals() : void {
        const modal_overlays = document.getElementsByClassName('ui-widget-overlay');

        for (const modal_overlay of modal_overlays) {
            let next_overlay_sibling = modal_overlay.nextElementSibling;
            while (next_overlay_sibling) {
                if (next_overlay_sibling.classList.contains('ui-dialog')) {
                    modal_overlay.style.zIndex = next_overlay_sibling.style.zIndex - 1;
                    break;
                }
                next_overlay_sibling = next_overlay_sibling.nextElementSibling;
            }
        }
    }

    /**
     * Move the accessories carousel forward or back based on the button clicked.
     * 
     * @param {string} direction the direction we want to scroll based on the button clicked.
     * @returns {void}
     */
    translate_accessories_carousel(direction: string) : void {
        const accessories_wrapper = document.querySelector('.accessories-container .owl-wrapper');
        const accessories_list = document.querySelectorAll('.accessories-container .owl-item');
        const current_position = parseInt(accessories_wrapper.style.left, 10);
        // Dynamically grab the width of a scroller item to set the distance to scroll.
        let distance = parseInt(document.querySelector('.accessories-container .owl-item').style.width, 10);
        const carousel_width = document.querySelector('.accessories-container .owl-wrapper-outer').offsetWidth;
        const upper_limit = (-1 * distance) * accessories_list.length + carousel_width;
        const lower_limit = 0;

        if (direction === 'next') {
            // Convert to negative if scrolling items to the left.
            distance = distance * -1;
        }

        // Move the carousel according to current position.
        if (current_position + distance > lower_limit) {
            accessories_wrapper.style.left = upper_limit + "px";
        } else if (current_position + distance < upper_limit) {
            accessories_wrapper.style.left = lower_limit + "px";
        } else {
            accessories_wrapper.style.left = (current_position + distance) + "px";
        }

    }
}

export function init() {
    if (document.querySelector('.tv-added-cart-products') || document.querySelector('#cart_items')) {
        (() => new CartView())();
    }
}

